import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';

export const LimitUpgradeDialog = ({
  open,
  onOpenChange,
  title = 'Límite de plan alcanzado',
  description = 'Tu licencia llegó al tope permitido.',
  current = 0,
  limit = 0,
  testIdPrefix = 'limit-upgrade',
}) => {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-md bg-[#0a0c12] border-red-500/20" data-testid={`${testIdPrefix}-dialog`}>
        <DialogHeader>
          <DialogTitle className="text-red-400" data-testid={`${testIdPrefix}-title`}>{title}</DialogTitle>
          <DialogDescription className="text-xs text-muted-foreground" data-testid={`${testIdPrefix}-description`}>
            {description}
          </DialogDescription>
        </DialogHeader>

        <div className="rounded-lg border border-red-500/20 bg-red-500/10 px-3 py-2" data-testid={`${testIdPrefix}-counter`}>
          <p className="text-xs text-red-300">
            Uso actual: <span className="font-semibold">{current}</span> / <span className="font-semibold">{limit}</span>
          </p>
        </div>

        <div className="grid grid-cols-1 gap-2">
          <Button
            variant="outline"
            onClick={() => {
              window.open('mailto:soporte@dealider.com?subject=Upgrade%20de%20plan', '_blank');
            }}
            className="border-white/15 text-xs"
            data-testid={`${testIdPrefix}-contact-button`}
          >
            Contactar soporte comercial
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};
